import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { addNotifyContactsToSubscriptionGroups } from "../../../queries/notify";
import { buildNotifyContactsQueryKey } from "./useInfiniteNotifyContacts";
import { useToasts } from "react-toast-notifications";
import { ToastStatuses } from "../../../components/global_components/Toast";

// Removes multiple Notify Contacts and all subscirber contact methods from multiple subscription groups
export function useNotifyContactsBulkAddToSubscriptionGroups() {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [addNotifyContactsToSubscriptionGroupsMutation, { isLoading: isAddNotifyContactsToSubscriptionGroupsLoading }] =
    useMutation(addNotifyContactsToSubscriptionGroups(networkHeaders), {
      onSuccess: async () => {
        await queryCache.invalidateQueries(buildNotifyContactsQueryKey());
        addToast("Contacts successfully Added to groups", { appearance: ToastStatuses.Success, autoDismiss: true });
      },
      onError: () => {
        addToast("Failed to remove contacts from groups", { appearance: ToastStatuses.Error, autoDismiss: true });
      },
    });

  const bulkAddNotifyContactsToSubscriptionGroups = async ({
    notifyContactIds,
    subscriptionGroupIds,
    overwriteExistingPreference,
  }: {
    notifyContactIds: number[];
    subscriptionGroupIds: number[];
    overwriteExistingPreference?: boolean;
  }) => {
    return await addNotifyContactsToSubscriptionGroupsMutation({
      subscriptionGroupIds,
      notifyContactIds,
      overwriteExistingPreference,
    });
  };

  return { bulkAddNotifyContactsToSubscriptionGroups, isAddNotifyContactsToSubscriptionGroupsLoading };
}
